const loadItem = (type, path) => {
  try {
    return require(`./types/${type}`).default;
  } catch (e) {
    throw new Error(
      `Error loading player for type ${type} at path ${path}, (${e})`,
    );
  }
};

export default loadItem;
